export default "__VITE_ASSET__ypJpX5DM__"